export class LoanRolesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLoanRoles({ companyId, ...params }) {
    return this.#http.get(`/api/companies/${companyId}/loanRoles`, {
      params,
    });
  }

  // DEV-4716 facade contract: the per-subcompany exposure projection a broker/TPO user reads to know
  // which loan roles are staffable on its loans (own roles + lender roles exposed to its subco) plus
  // their Required flag and provenance. Returns [{ loanRoleId, name, ownerSubCompanyId, required,
  // source, isRevoked, isLocked, isOwnRole, capacity, humanAssignmentEnabled }]. Degradable broker
  // read: skip the global forbidden-status page-reload interceptor so a 403 shows an in-panel error.
  async getLoanRoleExposures({ companyId, subCompanyId }) {
    return this.#http.get(`/api/companies/${companyId}/loanRoles/exposures`, {
      params: { subCompanyId },
      skipResponseInterceptor: { forbiddenError: true },
    });
  }
}
